import { distinctUntilChanged, take } from 'rxjs/operators';
import { Router } from '@angular/router';
import { SignUpPage } from './../sign-up/sign-up.page';
import { PlayerHomePage } from './../player-home/player-home.page';
import { MygolfGotoPageHandler } from './../mygolfapp-gotopage-handler';
import { ForgotPasswordPage } from './../forgot-password/forgot-password.page';
import { ConnectionService } from './../../../providers/connection-service/connection-service';
import { MessageDisplayUtil } from './../../../message-display-utils';
import { Component, ViewChild, Input, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { AppVersion } from '@awesome-cordova-plugins/app-version/ngx';
import { Keyboard } from '@awesome-cordova-plugins/keyboard/ngx';
import { Network } from '@awesome-cordova-plugins/network/ngx';
import {
  AlertController,
  IonApp,
  MenuController,
  ModalController,
  NavController,
  NavParams,
  Platform,
  ToastController,
} from '@ionic/angular';
import { Observable, Subscription } from 'rxjs';
import {
  CurrentUser,
  SessionInfo,
  SessionState,
} from './../../../data/authentication-info';
import { ServerInfo } from './../../../data/server-info';
import * as global from 'src/globals';
import { DeviceService } from '../../../providers/device-service/device-service';
import { GotoPageHandlerInterface } from '../../../providers/pushnotification-service/pushnotification-handler';
import { SessionDataService } from '../../../redux/session/session-data-service';
import { isPresent } from 'src/providers/common-service';
import { AuthenticationService } from 'src/authentication-service';
import { SessionActions } from 'src/redux/session';
import { ServerInfoActions } from 'src/redux/server';
import { PushNotificationService } from 'src/providers/pushnotification-service/pushnotification-service';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';
import { ClubFlightService } from '../../../providers/club-flight-service/club-flight-service';
import { ClubDataLite, ClubInfo, DiscountCompany } from '../../../data/mygolf.data';
import * as moment from 'moment';


@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.page.html',
  styleUrls: ['./sign-in.page.scss'],
})
export class SignInPage implements OnInit {
  username: AbstractControl;
  password: AbstractControl;
  authForm: FormGroup;
  showLogin: boolean = false;
  state: string = 'initializing';
  initializationError: string;
  serverInfo: ServerInfo;
  showPassword: boolean;
  serverUnreachable: boolean;
  private gotoPageHandler: GotoPageHandlerInterface;
  private sessionStatusSubscription: Subscription;
  retryClicked: boolean = false;
  appAttribute: any;
  @ViewChild('input') myInput;
  webParam: any;
  _timeout;
  appType: string = 'main';
  isDebugMode: boolean;
  logoRadiusParam: string;
  constructor(
    private nav: Router,
    private navController: NavController,
    public sessionDataService: SessionDataService,
    private app: IonApp,
    private keyboard: Keyboard,
    private connService: ConnectionService,
    private menu: MenuController,
    private alertCtl: AlertController,
    private toastCtl: ToastController,
    private fb: FormBuilder,
    private platform: Platform,
    private sessionActions: SessionActions,
    private serverActions: ServerInfoActions,
    private pushService: PushNotificationService,
    private mg2uUtil: mygolfUtils,
    private flightService: ClubFlightService,
  ) {

    this.menu.enable(false);
    this.authForm = this.fb.group({
      username: new FormControl('', [Validators.required, Validators.minLength(3)]),
      password: new FormControl('', [Validators.required]),
    });
    this.username = this.authForm.controls['username'];
    this.password = this.authForm.controls['password'];
    this.gotoPageHandler = new MygolfGotoPageHandler();
    this.appType = global.appType;
    let _param = this.mg2uUtil.getClubId();
    let _logoRadius = this.platform.getQueryParam('logoRadius');
    this.logoRadiusParam = this.platform.getQueryParam('logoRadius');
    if (_logoRadius && _logoRadius === 'false') {

      let clubSignInLogo = document.documentElement.querySelector('.club-sign-in-logo');
      //  .querySelector('.club-sign-in-logo');

      // setProperty('border-radius','0%','important');// .style.setProperty('--new-height','calc(100% - 8em)','important');
      if (clubSignInLogo) {
        clubSignInLogo.setAttribute('border-radius', '0%')
        // clubSignInLogo.style.borderRadius = '0%';
      }
    } else {
      // let clubSignInLogo = el.nativeElement.querySelector('.club-sign-in-logo');
      // if(clubSignInLogo) clubSignInLogo.style.borderRadius = '50%';
      let clubSignInLogo = document.querySelector('.club-sign-in-logo')
      // let clubSignInLogo = document.documentElement.querySelector('.club-sign-in-logo');

      //  .querySelector('.club-sign-in-logo');
      // setProperty('border-radius','0%','important');// .style.setProperty('--new-height','calc(100% - 8em)','important');
      if (clubSignInLogo) {
        clubSignInLogo.setAttribute('border-radius', '50%')
        // clubSignInLogo.style.borderRadius = '0%';
      }
    }
    this.isDebugMode = this.platform.getQueryParam('isDebugMode') === 'true' ? true : false;

    if (_param) {
      this.mg2uUtil.setClubSpecific(true);
      this.mg2uUtil.setClubId(_param);
      this.mg2uUtil.setClubParam(true);
      // window.resizeTo(500, 500);
      // this.appType = 'club';
    } else {
      if (this.appType === 'club' && global.clubId) {
        this.mg2uUtil.setClubSpecific(true);
      }
      else this.mg2uUtil.setClubSpecific(false)
    }


    if(this.mg2uUtil.webPartner && this.mg2uUtil.webPartnerId !== undefined) {
      this.getPartnerAttribute();
    }
  }

  ngOnInit() {
    this.getAppAttribute();
    // let _param = Number(this.platform.getQueryParam('param'));
    // let _hasParam = this.platform.getQueryParam('param');
    if (this.mg2uUtil.getClubParam()) {
      // let selectedClub: ClubInfo;
      let _clubId = this.mg2uUtil.getClubId();
      this.flightService.getClubListLite(_clubId)
        .subscribe((data: any) => {
          this.mg2uUtil.setSelectedClub(data);
          this.mg2uUtil.setClubParam(true);
        }, (error) => {

        }, () => {

          let _appAttribute = this.mg2uUtil.getSpecificAppAttributePage('playerHome');

          if (_clubId) {
            if (_appAttribute && _appAttribute.clubSpecificThemes) {
              _appAttribute.clubSpecificThemes.filter((cc) => {
                return cc.enableTheme && cc.clubId === Number(_clubId);
              }).map((cc) => {

                this.updateColor(cc.themeName)
              })
            }

          }
        })
    }
    this.platform.ready().then(() => {
      this.pushService.setControllers(this.app, this.navController, this.alertCtl,
        this.toastCtl, this.gotoPageHandler);

      // this.onPageInit();

      setTimeout(() => {
        this._init();
        this.webParam = this.mg2uUtil.getClubParam();
        // this.myInput.setFocus();
        //this.keyboard.show();
      }, 500);
    });

    this.serverUnreachable = !this.connService.isConnected();
  }

  ionViewWillUnload() {
    if (this.sessionStatusSubscription) {
      this.sessionStatusSubscription.unsubscribe();
      this.sessionStatusSubscription = null;
    }
  }
  ionViewDidEnter() {

  }

  ionViewWillLeave() {
    if (this.platform.is('ios') && this.platform.is('capacitor')) {
      this.keyboard.hide();
    }
  }

  toggleShowPassword(event) {

    this.showPassword = !this.showPassword;
    return false;
  }

  public onPageInit(retry?: boolean) {
    this.retryClicked = retry;
    setTimeout(() => {
      this.retryClicked = false;
    }, 10000);
    this.serverActions.refresh();
  }



  private _init() {
    this.serverActions.refresh();
    this.sessionDataService.showLoginForm().subscribe((show: boolean) => {
      this.showLogin = show;

      if (show) {
        this.sessionDataService.getCurrentUser()
          .subscribe((currUser: CurrentUser) => {
            this.username.setValue(currUser.userName);
          });
      }

    });

    this.sessionDataService.getServerInfo()
      .subscribe((serverInfo: ServerInfo) => {

        //
        this.serverInfo = serverInfo
        if (this.serverInfo && this.serverInfo.success === false) {
          this._timeout = setTimeout(() => {
            this.onSignout();
            clearTimeout(this._timeout);
          }, 5000)
        } else if (this.serverInfo && this.serverInfo.success === true) {
          clearTimeout(this._timeout);
        }
      });

    this.sessionStatusSubscription = this.sessionDataService.getSessionStatus()
      .pipe(distinctUntilChanged())
      .subscribe((status: SessionState) => {
        //
        this.sessionDataService.getSession()
          .pipe(take(1))
          .subscribe(async (session: SessionInfo) => {
            //
            if (status === SessionState.LoginFailed) {
              // second show toast - wrong password enter
              let toast = await this.toastCtl.create({
                message: session.exception,
                duration: 5000,
                buttons: [
                  {
                    text: 'cancel',
                    role: 'cancel',
                    handler: () => {

                    },
                  },
                ],
              });
              toast.present().then(() => {
                this.sessionActions.clearLoginError();
              });
              MessageDisplayUtil.showErrorToast(session.exception, this.platform, this.toastCtl, 5000, 'bottom');

            }
            else if (status === SessionState.LoggedIn) {
              if (session && !session.password) {
                this.onSignout()
              } else this.mainPage(session);
              if (this._timeout) clearTimeout(this._timeout);
            } else if (status === SessionState.LoggedOut) {
              this.onSignout();
            } else {
              if (session && session.password) {
                if (session && session.userName) this.username.setValue(session.userName);
                this.password.setValue(session.password);
                this.signin();
              }
            }

          }, (error) => {
          });


      });


  }



  async mainPage(session?: SessionInfo) {
    this.menu.enable(true);

    // console.debug('main page : ', session)
    // session = this.auth.currentSession();
    if (this.platform.is('ios') && this.platform.is('capacitor')) {
      this.keyboard.hide();
    }
    //
    if (isPresent(session)) {
      if (session.userType === 'Player') {
        if (session.user && session.user.partnerId)
          this.checkAndSetPartnerType(session.user.partnerId)
        else this.mg2uUtil.setUserType(null);
        let _hasParam = Number(this.mg2uUtil.getClubId());
        if (_hasParam) {
          let selectedClub: ClubInfo;
          let _clubId = _hasParam;
          this.flightService
            // .getClubListLite(_clubId)
            .getClubInfo(_clubId)
            .subscribe(async (data: ClubDataLite) => {
              this.mg2uUtil.setSelectedClub(data);
              this.mg2uUtil.setClubParam(true);
              this.nav.navigate(['/tabs/player-home'], { replaceUrl: true });
              setTimeout(() => {
                // queryParams: { param: 310510379 },
                this.nav.navigate(['booking-home'], {
                  state: {
                    userType: 'player',
                    isClubSpecific: true,
                    club: data,
                    clubSpecificThemes: this.appAttribute && this.appAttribute.clubSpecificThemes ? this.appAttribute.clubSpecificThemes : null
                  }
                })
              }, 1500);
            })
        } else {
          this.nav.navigate(['/tabs/player-home'], { replaceUrl: true });
        }

      } else {
        this.nav.navigate(['/tabs/app-home']);
      }
      // else if (session.userType === 'Club') {
      //   // this.nav.setRoot(ClubHomePage);

      // }
    } else {
    }
  }


  checkAndSetPartnerType(partnerId: string) {

    this.flightService.getPartnerDetails(partnerId)
      .subscribe((data: any) => {

        if (data) {
          if (data.partnerServices) {
            data.partnerServices.filter((service) => {
              return service.toLowerCase().includes('booking_agent')
            }).map((service) => {
              this.mg2uUtil.setUserType('booking_agent');
              this.mg2uUtil.setPartnerInfo(data);
            })
          }
        }
        // this.mg2uUtil.setUserType
      })
  }

  public signin() {
    if (!this.authForm.value.username || !this.authForm.value.password) {
      let subTitle = "Please enter email and password";
      MessageDisplayUtil.displayErrorAlert(this.alertCtl, "", subTitle, "OK");
      if (this.platform.is('ios') && this.platform.is('capacitor')) {
        this.keyboard.hide();
      }
      return false;
    }
    if (this._timeout) clearTimeout(this._timeout);
    this.sessionActions.login(this.authForm.value.username, this.authForm.value.password, 'club');
  }

  signup() {
    this.nav.navigate(['sign-up']);
    // this.nav.push(SignUp);
  }

  forgotPassword() {
    this.nav.navigate(['forgot-password']);

  }
  exitApp() {
    // navigator['app'].exitApp();
  }

  isCordova() {
    return this.platform.is('capacitor');
  }

  onSignout() {
    this.sessionActions.logout();
  }

  getClubLogo(type?: string) {

    //
    if (global.appType === 'club' && global.clubId === 310510386) {
      return 'assets/img/club-logo/minesLogo.png'
    } else if (global.appType === 'club') {
      return this.mg2uUtil.getClubLogo('logo');
    }
    else if (global.appType === 'main' && global.clubId === null && this.mg2uUtil.getClubParam()) {      //
      return this.mg2uUtil.getClubSpecificHeader('header-logo'); //.getClubLogo('logo');
    }
    else if (type === 'header' && this.getPartnerSignInLogo()) {
      return this.getPartnerSignInLogo();
    } else if(type === 'header') {
      return 'assets/img/main-round-logo.svg';
    }
    else {
      return 'assets/img/mg2u-circle-512.png';
    }
  }

  getAppAttribute() {

    this.flightService.getAppAttributes()
      .subscribe((data: any) => {
        //
        if (data) {
          this.mg2uUtil.setAppAttributes(data);
          data.filter((d) => {
            return d.page === 'playerHome'
          }).map((d) => {
            this.appAttribute = d
          });
          //
          if (this.appAttribute) {
            if (this.appAttribute.maintenance) {
              this.displayMaintenance(this.appAttribute);
            }
            if (global.appType === 'club' && global.clubId && global.clubId === 310510386) {
              this.updateColor('gold');
            }
            // if (this.appAttribute.announcement) {
            //     this.displayAnnouncement(this.appAttribute);
            // }
          }
        }
      })
  }


  getPartnerAttribute() {
    this.flightService.getPartnerAttributes()
      .subscribe((data: any) => {
        // console.debug("get partner attributes ", data)
        if (data) {
          this.mg2uUtil.setPartnerAttributes(data);
        }
      })
  }

  async displayMaintenance(appAttribute) {
    if (!appAttribute) return false;
    let _maintenance = appAttribute.maintenance;
    let _fromDate = _maintenance.fromDate;
    let _daysBefore = _maintenance.daysBefore;
    let _dateBefore;
    if (_daysBefore) _dateBefore = moment(_fromDate).add(-1 * _daysBefore, "days");
    let _toDate = _maintenance.toDate;
    // if(_daysBefore) _dateBefore = moment(_toDate).add(-1*_daysBefore, "days");
    let _fromTime = _maintenance.fromTime;
    let _toTime = _maintenance.toTime;

    let _fromDateTime = moment(_fromDate + _fromTime, "YYYY-MM-DDHH:mm");
    // moment(_dateBefore).format("YYYY-MM-DD")

    let _toDateTime = moment(_toDate + _toTime, "YYYY-MM-DDHH:mm");
    //
    //
    //
    //
    //
    //
    if (_maintenance.showMaintenanceMessage) {
      // let _msg = "Server is currently under maintenance. <br>Scheduled time <br><b>"+moment(_fromDateTime).format("ddd, DD MMM YYYY HH:mm") + "</b> to <b>" + moment(_toDateTime).format("ddd, DD MMM YYYY HH:mm")+"</b>";
      let _msg = "The system will be unavailable during the following period : <br><b>" + moment(_fromDateTime).format("ddd, DD MMM YYYY HH:mm") + "</b> to <br><b>" + moment(_toDateTime).format("ddd, DD MMM YYYY HH:mm") + "</b>";
      if (_maintenance.maintenanceMessage) {
        _msg = _maintenance.maintenanceMessage + "<br><b>" + moment(_fromDateTime).format("ddd, DD MMM YYYY HH:mm") + "</b> to <br><b>" + moment(_toDateTime).format("ddd, DD MMM YYYY HH:mm") + "</b>";
      }
      let _buttons = [];
      if (_maintenance.blockForMaintenance && moment().isBetween(_fromDateTime, _toDateTime, 'minute')) {
        if (this.platform.is("cordova"))
          _buttons.push({
            text: "Close",
            role: "cancel",
            handler: () => {
              if (this.platform.is("cordova"))
                _alert.dismiss(true);
              return false;
            }
          })

      } else {
        _buttons.push({
          text: "Okay",
          role: "cancel",
          handler: () => {
            _alert.dismiss(false);
            return false;
          }
        })
      }
      let _alert = await this.alertCtl.create({
        header: "Server Maintenance",
        message: _msg,
        buttons: _buttons,
        backdropDismiss: _maintenance.blockForMaintenance ? false : true
      });
      _alert.onDidDismiss().then((exit: any) => {
        // if (exit) this.platform.exitApp();
      });
      // if(moment().isBetween(_fromDate + " " + _fromTime, _toDate + " " + _toTime ))
      //
      //
      //
      // if(moment().isBetween(_fromDateTime, _toDateTime,'minute') ||  moment().isBetween(_dateBefore,moment(_toDate,"YYYY-MM-DD")))
      if (moment().isBetween(_dateBefore, _toDateTime, 'minute'))
        _alert.present();
      // .endOf('day')
    }
  }

  updateColor(themeName?: string, reset?: boolean) {
    // document.documentElement.style.setProperty(`--color`, color);
    //
    if (themeName)
      document.body.className = "theme-" + themeName;
    else document.body.className = "";
    // .toggle(color);
    // document.documentElement.style.setProperty(`--ion-border-color`, color);
  }

  getClubBanner() {
    if (global.appType === 'club' && global.clubId === 310510386) {
      if (this.mg2uUtil.getClubLogo('banner'))
        return this.mg2uUtil.getClubLogo('banner')
      else return global.MygolfServer + "/document/assets/clubSpecific/banner/minesBanner.png"
    } else if (global.appType === 'club') {
      if (this.mg2uUtil.getClubLogo('banner'))
        return this.mg2uUtil.getClubLogo('banner')
      else return 'assets/img/mg2u-circle-512.png'
    }
    else return 'assets/img/mg2u-circle-512.png'; //'assets/img/New-myGolf2u.png';//
  }

  canSignUp() {

    // if(this.appType !== 'main') return;
    if (global.appType === 'club' && !global.clubId) return;
    let _appAttribute = this.mg2uUtil.getSpecificAppAttributePage('mainApp');
    let _enableSignUp = [];

    if (_appAttribute && _appAttribute.clubEnablePlayerSignUp)
      _enableSignUp = _appAttribute.clubEnablePlayerSignUp.filter((clubId) => {
        return clubId === global.clubId
      })

    return _enableSignUp && _enableSignUp.length > 0 && !this.isCordova()
  }

  getClassSignInLogo() {
    if (global.appType === 'club' && global.clubId === 310510386) {
      if (this.mg2uUtil.getClubLogo('banner'))
        return 'sign-in-logo';
      else return 'sign-in-logo';
    }
    else if (global.appType === 'main' && global.clubId === null && this.mg2uUtil.getClubParam()) {
      if (this.logoRadiusParam === 'true')
        return 'club-sign-in-logo logo-radius-50'
      else if (this.logoRadiusParam === 'false')
        return 'club-sign-in-logo no-logo-radius'
      else return 'club-sign-in-logo logo-radius-50';

    }
    else return 'sign-in-logo';

  }

  getClassSignInBackground() {
    if (global.appType === 'club' && global.clubId === 310510386) {
      if (this.mg2uUtil.getClubLogo('banner'))
        return ''
      else return '';
    } else if (global.appType === 'club') {
      return '';
    }
    else if (global.appType === 'main' && global.clubId === null && this.mg2uUtil.getClubParam()) {
      return 'club-sign-in-background';
    }
    else return 'mygolf-special-page-background';
  }

  debugMode(attribute: string) {
    switch (attribute) {
      case 'splash':
        return this.isDebugMode;
      case 'sign-in':
        return !this.isDebugMode;
    }
  }

  getSignInBg() {

    if(this.mg2uUtil.webPartner && this.mg2uUtil.webPartnerId, this.mg2uUtil.partnerAttributes) {
      let _partnerId = this.mg2uUtil.webPartnerId;
      let _partnerThemes = this.mg2uUtil.partnerAttributes?.partnerSpecificThemes;
      let _theme;
      // console.debug("sign in bg ", this.mg2uUtil.partnerAttributes, _partnerThemes, _partnerId);
      if(_partnerThemes && _partnerThemes.length > 0)
        _partnerThemes.filter((t)=>{
          return t.partnerId === _partnerId;
        }).map((t)=>{
          _theme = t
        })
        // console.debug("sign in bg [2] ", _theme);
        if(_theme)
          return global.MygolfServer+'/'+_theme?.signInBg;
        else return '../../../assets/img/loginBg.png';
    } else return '../../../assets/img/loginBg.png';
  }

  getPartnerSignInLogo() {
    if(this.mg2uUtil.webPartner && this.mg2uUtil.webPartnerId, this.mg2uUtil.partnerAttributes) {
      let _partnerId = this.mg2uUtil.webPartnerId;
      let _partnerThemes = this.mg2uUtil.partnerAttributes?.partnerSpecificThemes;
      let _theme;
      // console.debug("sign in bg ", this.mg2uUtil.partnerAttributes, _partnerThemes, _partnerId);
      if(_partnerThemes && _partnerThemes.length > 0)
        _partnerThemes.filter((t)=>{
          return t.partnerId === _partnerId;
        }).map((t)=>{
          _theme = t
        })
        // console.debug("sign in bg [2] ", _theme);
        if(_theme)
          return global.MygolfServer+'/'+_theme?.signInLogo;
        else return 'assets/img/main-round-logo.svg';
    }
  }
}
